import React from 'react';
import PropTypes from 'prop-types';
import ReactTable from 'react-table';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import { HOC } from 'formsy-react';
import globals from '../../../globals/communityGlobals';
import VisitActualActivityForm from './VisitActualActivityForm';
import VisitActualActivitiesDialog from './VisitActualActivitiesDialog';

const locale = globals.getArea('visitActuals');

class VisitActualActivitiesTable extends React.Component {
  constructor(props) {
    super(props);
    this.setValidator(props);
  }

  state = { open: false, activity: null };

  componentWillReceiveProps(nextProps) {
    this.setValidator(nextProps);
  }

  setValidator = props => {
    props.setValidations(this.validations, props.required);
  };

  validations = {
    state: (values, value) => {
      if (
        value &&
        !value.every(
          a =>
            (a.isCompleted === true && a.minutesSpent > 0) ||
            (a.isCompleted === false && a.reason && a.reason.length > 0),
        )
      ) {
        return locale.getMsg('incompleteActivity');
      }

      return true;
    },
    time: (values, value) => {
      const { visitTime } = this.props;

      if (visitTime && visitTime < this.totalTime(value)) {
        return locale.getMsg('visitTimeTooShort');
      }

      return true;
    },
  };

  handleOpen = activity => this.setState({ open: true, activity });

  handleClose = () => this.setState({ open: false });

  get activities() {
    if (this.props.clearActivities) return [];
    if (this.props.filteredActivitiesByOrgUnit) return this.props.filteredActivitiesByOrgUnit;
    const { getValue } = this.props;
    return getValue() || [];
  }

  totalTime = activities =>
    activities
      .filter(activity => activity.isCompleted === true)
      .reduce((sum, activity) => sum + activity.minutesSpent || 0, 0);

  handleAdd = activity => {
    this.props.handleActivitiesReset();

    const { setValue, addActivityTime, addedActivities } = this.props;
    const activities = this.activities;
    const newActivity = Object.assign({}, activity);

    newActivity.isAdditional = true;

    setValue([...activities, newActivity]);
    if (addActivityTime) addActivityTime(activity.duration);
    if (addedActivities) addedActivities([...activities, newActivity]);
  };

  handleEdit = activity => {
    const { setValue } = this.props;
    const activities = this.activities;
    const foundIndex = activities.findIndex(a => a.id === activity.id);

    activities[foundIndex] = activity;

    setValue([...activities]);
  };

  errors = () => {
    const { getErrorMessages } = this.props;
    const errors = getErrorMessages();

    return (
      <ul className="error">
        {errors.map(e => (
          <li key={`error${e}`}>{e}</li>
        ))}
      </ul>
    );
  };

  render() {
    const { maxBand, visitTime, canEdit, isSuccessfullyCompleted } = this.props;
    const activities = this.activities;

    const usedActivitiesId = this.activities.map(a => a.id);
    const totalTime = this.totalTime(activities);
    const timeLeft = visitTime ? visitTime - this.totalTime(activities) : null;

    const columns = [
      {
        Header: locale.getMsg('minutesSpent'),
        id: 'minutesSpent',
        accessor: row => (row.minutesSpent ? row.minutesSpent : '-'),
        width: 200,
        Footer: (
          <span>
            <strong>{locale.getMsg('totalTime')}:</strong> {locale.getMsg('minutesFormat', [`${totalTime}`])}
            <br />
            <strong>{timeLeft && `${locale.getMsg('timeLeft')}:`}</strong>{' '}
            {timeLeft && locale.getMsg('minutesFormat', [`${timeLeft}`])}
          </span>
        ),
      },
      {
        Header: locale.getMsg('name'),
        accessor: 'name',
        width: 400,
      },

      {
        Header: locale.getMsg('additional'),
        id: 'isAdditional',
        accessor: row => (row.isAdditional ? '✔' : '-'),
        width: 200,
        style: { paddingLeft: '20px' },
      },
      {
        Header: locale.getMsg('completed'),
        id: 'isCompleted',
        accessor: row => {
          if (row.isCompleted === true) return '✔';
          if (row.isCompleted === false) return '-';

          return '?';
        },
        width: 200,
        style: { paddingLeft: '20px' },
      },
      {
        Header: locale.getMsg('reason'),
        accessor: 'reason',
        width: 400,
      },
    ];

    return (
      <div style={{ width: '100%' }}>
        <Dialog
          label={locale.getMsg('editActivity')}
          open={this.state.open}
          onClose={this.handleClose}
          disableBackdropClick
        >
          <DialogContent>
            <VisitActualActivityForm
              maxBand={maxBand}
              treatmentInstanceId={this.props.treatmentInstanceId}
              isSuccessfullyCompleted={isSuccessfullyCompleted}
              activity={this.state.activity}
              onRequestClose={this.handleClose}
              onRequestSubmit={this.handleEdit}
              visitType={this.props.visitType}
              filterActivitiesByOrgUnit={options => this.props.filterActivitiesByOrgUnit(options)}
            />
          </DialogContent>
        </Dialog>
        <ReactTable
          manual
          minRows={1}
          columns={columns}
          data={activities}
          page={0}
          pages={0}
          pageSize={100}
          showPagination={false}
          getTrGroupProps={(state, rowInfo) => ({
            onClick: () => {
              if (canEdit || !isSuccessfullyCompleted) {
                this.handleOpen(rowInfo.original);
              }
            },
          })}
        />
        {(canEdit || !isSuccessfullyCompleted) && (
          <div className="activities-button-wrapper">
            <div className="row">
              <div className="col-c3">{this.errors()}</div>
            </div>
            <div className="row">
              <div className="col-c3">
                <VisitActualActivitiesDialog
                  isSuccessfullyCompleted={isSuccessfullyCompleted}
                  treatmentInstanceId={this.props.treatmentInstanceId}
                  usedActivities={usedActivitiesId}
                  onAdd={activity => this.handleAdd(activity)}
                  visitType={this.props.visitType}
                  filterActivitiesByOrgUnit={options => this.props.filterActivitiesByOrgUnit(options)}
                />
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }
}

VisitActualActivitiesTable.defaultProps = {
  value: [],
  maxBand: undefined,
  visitTime: undefined,
  addActivityTime: () => {},
  addedActivities: () => {},
  treatmentInstanceId: undefined,
  visitType: '',
  handleActivitiesReset: () => {},
  filterActivitiesByOrgUnit: () => {},
};

VisitActualActivitiesTable.propTypes = {
  canEdit: PropTypes.bool.isRequired,
  maxBand: PropTypes.number,
  visitTime: PropTypes.number,
  getValue: PropTypes.func.isRequired,
  setValue: PropTypes.func.isRequired,
  getErrorMessages: PropTypes.func.isRequired,
  addActivityTime: PropTypes.func,
  treatmentInstanceId: PropTypes.number,
  addedActivities: PropTypes.func,
  visitType: PropTypes.string,
  handleActivitiesReset: PropTypes.func,
  filterActivitiesByOrgUnit: PropTypes.func,
};

export default HOC(VisitActualActivitiesTable);
